/**
 * Dispatches an event from the provided element.
 * @param {EventTarget} $from The source of the event.
 * @param {string} eventName The name of the event.
 * @param {any} detail The detail of the event.
 * @param {boolean} bubbles Can the event bubble. Default is true.
 * @param {boolean} cancelable Can the event bubble. Default is true.
 */
export function dispatchEvent($from, eventName, detail, bubbles = true, cancelable = true) {
    const event = new CustomEvent(eventName, {detail, bubbles, cancelable});
    $from.dispatchEvent(event);
}
